import * as React from 'react';

import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice';
import { DEVICES } from 'utils';

import EntityDesktop from './EntityDesktop';
import EntityMobile from './EntityMobile';

interface EntityCardProps {
  onClick: (e: any) => void;
  item: any;
  disabled?: boolean;
}

const EntityCard = ({
  item,
  onClick,
  disabled,
}: EntityCardProps): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);

  const renderElements = {
    [DEVICES.DESKTOP]: (
      <EntityDesktop disabled={disabled} item={item} onClick={onClick} />
    ),
    [DEVICES.MOBILE]: <EntityMobile item={item} onClick={onClick} />,
    [DEVICES.TABLET]: <EntityMobile item={item} onClick={onClick} />,
  };

  return <>{renderElements[appDevice.device]}</>;
};

export default EntityCard;
